import React from 'react'
import { Link } from 'react-router-dom'
import Select from 'react-select';

interface FilterTopProps {
    totalResults: number;
    showingFrom: number;
    showingTo: number;
    currentPage?: number;
    totalPages?: number;
    onPageChange?: (page: number) => void;
}

export default function FilterTop({ totalResults, showingFrom, showingTo, currentPage = 1, totalPages = 1, onPageChange }: FilterTopProps) {
    const item = [
        { value: '1', label: 'Low Price' },
        { value: '1', label: 'High Price' },
        { value: '1', label: 'Most Popular' },
    ];
    return (
        <div className="bg-white p-6 rounded-[2rem] border border-gray-100 shadow-sm mb-6">
            <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6">
                <div className="flex-1 flex flex-col md:flex-row md:items-center justify-between gap-4">
                    <div className="flex items-center gap-3">
                        <div className="w-2 h-8 bg-accent rounded-full"></div>
                        <h5 className="text-lg font-black text-gray-900">
                            Showing <span className="text-primary">{showingFrom}-{showingTo}</span> of <span className="text-primary">{totalResults}</span> results
                        </h5>
                    </div>
                    
                    {totalPages > 1 && (
                        <div className="flex items-center gap-2">
                            {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
                                <button
                                    key={p}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        onPageChange?.(p);
                                    }}
                                    className={`w-10 h-10 flex items-center justify-center rounded-xl text-sm font-black transition-all ${currentPage === p ? 'bg-primary text-white shadow-lg shadow-primary/20 scale-110' : 'bg-gray-50 text-gray-500 hover:bg-gray-100'}`}
                                >
                                    {p}
                                </button>
                            ))}
                        </div>
                    )}
                </div>

                <div className="w-full lg:w-72">
                    <div className="flex items-center gap-4">
                        <label className="text-xs font-black text-gray-400 uppercase tracking-widest whitespace-nowrap">Sort By:</label>
                        <div className="flex-1">
                            <Select 
                                options={item} 
                                className="react-select-container"
                                classNamePrefix="react-select"
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        borderRadius: '12px',
                                        border: '1px solid #f3f4f6',
                                        backgroundColor: '#f9fafb',
                                        padding: '2px',
                                        boxShadow: 'none',
                                        '&:hover': {
                                            borderColor: '#f1ae24'
                                        }
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? '#05144b' : state.isFocused ? '#f1ae2410' : 'white',
                                        color: state.isSelected ? 'white' : '#4b5563',
                                        fontWeight: '600',
                                        fontSize: '14px'
                                    })
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
